<template>
    <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
        <div data-template="template3" class="wrap-template template3">
            <div class="main-handicap m-hdp">
                <div class="vrow items-center template-title is_fold">
                    <div class="play-name col" @click="showLeg()">
                        <span class="ellipsis">{{ getTitleCaption() }}</span>
                    </div>
                    <div style="width: 37px;" @click="setToTop($event)">
                        <span class="set_top" style="display: none;">
                            <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
                        </span>
                    </div>
                </div>
                <template v-if="show">
                    <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
                        <template
                            v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
                            <template v-if="subMatchKey == 0">
                                <div class="handicap">
                                    <div class="handicap-item os-1">
                                        <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                                            <div class="bet-inner yb-flex-center fit">
                                                <div class="handicap-wrap">
                                                    <div class="bet-item">
                                                        <div class="item-label bet-ellipsis ellipsis">
                                                            <span class="ellipsis-wrap">
                                                                {{ sportAllBetLang['ALL_BET.LBL_05'] }}
                                                            </span>
                                                        </div>
                                                        <span class="ellipsis"></span>
                                                    </div>
                                                </div>
                                                <cstgftht :event="newAllBetEvent" :score="'0_5'" :plyType="plytyp" :betType="bettyp" ref="0_5" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap-item os-1">
                                        <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                                            <div class="bet-inner yb-flex-center fit">
                                                <div class="handicap-wrap">
                                                    <div class="bet-item">
                                                        <div class="item-label bet-ellipsis ellipsis">
                                                            <span class="ellipsis-wrap">
                                                                {{ sportAllBetLang['ALL_BET.LBL_16'] }}
                                                            </span>
                                                        </div>
                                                        <span class="ellipsis"></span>
                                                    </div>
                                                </div>
                                                <cstgftht :event="newAllBetEvent" :score="'1_6'" :plyType="plytyp" :betType="bettyp" ref="1_6" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap-item os-1">
                                        <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                                            <div class="bet-inner yb-flex-center fit">
                                                <div class="handicap-wrap">
                                                    <div class="bet-item">
                                                        <div class="item-label bet-ellipsis ellipsis">
                                                            <span class="ellipsis-wrap">
                                                                {{ sportAllBetLang['ALL_BET.LBL_27'] }}
                                                            </span>
                                                        </div>
                                                        <span class="ellipsis"></span>
                                                    </div>
                                                </div>
                                                <cstgftht :event="newAllBetEvent" :score="'2_7'" :plyType="plytyp" :betType="bettyp" ref="2_7" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap-item os-1">
                                        <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                                            <div class="bet-inner yb-flex-center fit">
                                                <div class="handicap-wrap">
                                                    <div class="bet-item">
                                                        <div class="item-label bet-ellipsis ellipsis">
                                                            <span class="ellipsis-wrap">
                                                                {{ sportAllBetLang['ALL_BET.LBL_38'] }}
                                                            </span>
                                                        </div>
                                                        <span class="ellipsis"></span>
                                                    </div>
                                                </div>
                                                <cstgftht :event="newAllBetEvent" :score="'3_8'" :plyType="plytyp" :betType="bettyp" ref="3_8" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap-item os-1 no_border_bottom">
                                        <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                                            <div class="bet-inner yb-flex-center fit">
                                                <div class="handicap-wrap">
                                                    <div class="bet-item">
                                                        <div class="item-label bet-ellipsis ellipsis">
                                                            <span class="ellipsis-wrap">
                                                                {{ sportAllBetLang['ALL_BET.LBL_49'] }}
                                                            </span>
                                                        </div>
                                                        <span class="ellipsis"></span>
                                                    </div>
                                                </div>
                                                <cstgftht :event="newAllBetEvent" :score="'4_9'" :plyType="plytyp" :betType="bettyp" ref="4_9" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap-item os-1 no_border_bottom">
                                        <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                                            <div class="bet-inner yb-flex-center fit">
                                                <div class="handicap-wrap">
                                                    <div class="bet-item">
                                                        <div class="item-label bet-ellipsis ellipsis">
                                                            <span class="ellipsis-wrap"></span>
                                                        </div>
                                                        <span class="ellipsis"></span>
                                                    </div>
                                                </div>
                                                <div class="odds yb-number-font">
                                                    <div class=""></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'
import allBetMixin from '../../../mixins/allBet'

export default {
    mixins: [allBetMixin],
    props: {
        allBetEvent: null,
        plytyp: null,
        selectMarket: null,
        removeMarket: null,
        rbinfo: null,
        bettyp: null,
        myMarket: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        },
        mode:null
    },
    data() {
        return {
            show: true,
        }
    },
    computed: {
        ...mapGetters([
            'foldopenAllBet',
            'foldopenFirstEvent'
        ]),
        newAllBetEvent() {
            // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
            return this.allBetEvent
        }
    },
    watch: {
        foldopenAllBet() {
            if(this.mode=='ab'){
                this.show = (this.$store.getters.foldopenAllBet) ? true : false;
            }
        },
        foldopenFirstEvent() {
            if(this.mode!='ab'){
                this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
            }
        }
    },
    methods: {
        getTitleCaption() {
            var team
            if (this.bettyp == this.hldsBetType || this.bettyp == this.rhldsBetType) {
                team = this.sportAllBetLang['ALL_BET.SUBHEADER_HLDS'] + this.newAllBetEvent.tacapt + ' - '
            } else if (this.bettyp == this.aldsBetType || this.bettyp == this.raldsBetType) {
                team = this.sportAllBetLang['ALL_BET.SUBHEADER_ALDS'] + this.newAllBetEvent.tbcapt + ' - '
            }

            return team + this.sportAllBetLang['ALL_BET.SUBHEADER_LAST_DIGIT']
        },
        showLeg() {
            this.show = (!this.show) ? true : false;
        },
        setToTop(d) {
            this.$parent.setToTop(d);
        },
        addToMyMarket(plytyp, bettyp) {
            if (this.selectMarket)
                this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
        },
        removeFromMyMarket(plytyp, bettyp) {
            if (this.removeMarket)
                this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
        },
        oddsHeader() {
            var retCapt = ''

            if (this.bettyp == this.hldsBetType) {
                retCapt += this.sportAllBetLang["ALL_BET.LBL_HTP"] + ": " + this.allBetEvent.tacapt
            } else if (this.bettyp == this.aldsBetType) {
                retCapt += this.sportAllBetLang["ALL_BET.LBL_ATP"] + ": " + this.allBetEvent.tbcapt
            }

            retCapt += " - " + this.sportAllBetLang['ALL_BET.LBL_LAST_DIGIT']

            return retCapt
        },
    },
    mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
}
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-lds.vue